import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    template: `
        <div class="sidebar-content">
            <ng-transclude></ng-transclude>
        </div>
        <style>
            learn-modal-materials-wrapper-sidebar-content {
                display: contents;
            }
        </style>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/learnModal/materialsWrapper/sidebar/content/index.js